import React, { ReactElement, useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { DefaultPlayer as Video } from "react-html5video";
import "react-html5video/dist/styles.css";

import { ref, getDownloadURL } from "firebase/storage";
import { storage } from "../../../apis/firebase";

import apiRequest from "../../../apis/request";

const CloudStorageVideo = (props): ReactElement => {
  const { settings } = props;
  const [isActive, setIsActive] = useState(false);
  const [isPaused, setIsPaused] = useState(true);
  const [_videoUrl, setVideoUrl] = useState(null);
  const time = useRef(0);
  const interval = useRef<any>();

  const { track } = useSelector(({ track }) => ({
    track: track,
  }));

  useEffect(() => {}, []);

  useEffect(() => {
    (async () => {
      if (settings?.videoUrl) {
        setVideoUrl(await getStorageFileUrl(settings.videoUrl));
      }
    })();

    return () => {
      time.current = 0;
      clearInterval(interval.current);
    };
  }, [settings?.videoUrl]);

  useEffect(() => {
    let interval = null;

    if (isActive && isPaused === false) {
      interval = setInterval(() => {
        time.current = time.current + 10;
      }, 10);
    } else {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [isActive, isPaused]);

  const handleStart = () => {
    setIsActive(true);
    setIsPaused(false);
  };

  const handlePauseResume = () => {
    setIsPaused(!isPaused);
  };

  const getStorageFileUrl = async (url): any => {
    if (!!url) {
      return await getDownloadURL(ref(storage, url));
    }
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
      }}>
      {_videoUrl && (
        <Video
          autoPlay
          controls={["PlayPause", "Seek", "Time", "Volume", "Fullscreen"]}
          onCanPlayThrough={() => {
            // Do stuff
          }}
          onPlay={() => {
            if (props.sessionId) {
              interval.current = setInterval(() => {
                apiRequest("POST", "/a/replay", [], {
                  trackId: track.docId,
                  sessionId: props.sessionId,
                  watchDuration: parseFloat(time.current / 1000),
                });
              }, 2000);
            }
            handleStart();
          }}
          onPause={() => {
            clearInterval(interval.current);
            handlePauseResume();
          }}>
          <source src={_videoUrl} type="video/mp4" />
        </Video>
      )}
    </div>
  );
};

export default CloudStorageVideo;
